// extracted by mini-css-extract-plugin
export default {"eventsContainer":"eventsContainer---DeuCg","fixedSessionBanner":"fixedSessionBanner---HNop7"};